//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const TotalValueOfAllProjectsWidget = ({ count }: { count: string | number }) => {
  return <StatCard title='Value Of All Projects' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default TotalValueOfAllProjectsWidget;
